import React from 'react'

export const Footer = () => {
    const footerAb = [
        {id: 1, title: 'О NEO BIT'},
        {id: 2, title: 'Почему NEO BIT?'},
        {id: 3, title: 'Доказательство доверия'},
        {id: 4, title: 'Верификация NEO BIT'},
        {id: 5, title: 'Центр прозрачности NEO BIT'},
        {id: 6, title: 'Сообщество NEO BIT'},
        {id: 7, title: 'Карта событий NEO BIT'},
        {id: 8, title: 'NEO BIT Ventures'},
        {id: 9, title: 'Фонд NEO BIT'},
        {id: 10, title: 'Свяжитесь с нами'},
    ]

    const footerProds = [
        {id: 1, title: '0 комиссии NEO BIT'},
        {id: 2, title: 'Спот'},
        {id: 3, title: 'Фьючерсы'},
        {id: 4, title: 'Бот сеточной торговли на фьючерсах'},
        {id: 5, title: 'Фьючерсный прогноз'},
        {id: 6, title: 'Фьючерсы на акции'},
        {id: 7, title: 'DEX+'},
        {id: 8, title: 'P2P'},
        {id: 9, title: 'Конвертировать'},
        {id: 10, title: 'Премаркет'},
        {id: 11, title: 'Копи-трейдинг'},
        {id: 12, title: 'Демо-трейдинг'},
        {id: 13, title: 'Заработок'},
        {id: 14, title: 'Займы'},
        {id: 15, title: 'Торговые комиссии'},
        {id: 16, title: 'NEO BIT ИИ'},
    ]

  return (
    <div id="footer">
        <div className="container">
            <div className="footer">
                <div className="footer-block">
                    <span>О нас</span>
                    {
                        footerAb.map(item => (
                            <div className="footer-item" key={item.id}>{item.title}</div>
                        ))
                    }
                </div>
                <div className="footer-block">
                    <span>Продукты</span>
                    {
                        footerProds.map(item => (
                            <div className="footer-item" key={item.id}>{item.title}</div>
                        ))
                    }
                </div>
                <div className="footer-block">
                    <span>Партнеры</span>
                    {
                        footerAb.map(item => (
                            <div className="footer-item" key={item.id}>{item.title}</div>
                        ))
                    }
                </div>
                <div className="footer-block">
                    <span>Правовые вопросы и соответствие требованиям</span>
                    {
                        footerAb.map(item => (
                            <div className="footer-item" key={item.id}>{item.title}</div>
                        ))
                    }
                </div>
            </div>
        </div>
    </div>
  )
}
